module.exports = __webpack_public_path__ + "img/rosenfeld-logo.f10530fa.png";